export default "__VITE_ASSET__LkhUe8Ki__"